import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import './error.css';
import ErrorImage from '../../../assets/images/image1.png';
import { useHistory, useLocation } from "react-router";
import { getTheme } from "../../../Utils/Utility";
import { AppConstatnt } from "../../../Utils/AppConstant";
import { useDispatch } from "react-redux";
import { clearError } from "@mobile-dev/platform/common/redux/actions/CommonAction";
import { injectIntl } from 'react-intl';

function ErrornDialog({ intl, error, open = false, isErrorBoundry = false, errorresponse }) {
    const [show, setShow] = useState(false);
    const dispatch = useDispatch();
    const history = useHistory();
    const { formatMessage } = intl;
    console.error("error inside error dialog", error)
    console.error("error response", errorresponse)
    useEffect(() => {
        setShow(open);
    }, [error]);

    const themeStyle = getTheme() === AppConstatnt.theme.DARK ? { backgroundColor: '#464f5b' } : {};

    const handleChange = () => {
        handleClose();
        history.push('/');
        window.location.reload();
        return null;
    }

    const handleClose = () => {
        setShow(false);
        dispatch(clearError());
    }

    const handleClick = (e) => {
        window.open('mailto:support@freightsmith.net?subject=Subject&body=Body%20goes%20here')
    }

    return (
        <React.Fragment>
            <Modal
                className="fade"
                show={show}
                onHide={handleClose}
                backdrop='static'
                keyboard={false}
            >
                <div className="modal-dialog-centered modal-content" style={themeStyle} >
                    <Modal.Body className="text-center">

                        <main class="main">
                            <div className="error">error</div>
                            <img src={ErrorImage} />
                            <h2 className="mb-3">Oh no!</h2>
                            <h6>{formatMessage({ id: "app.error_content" })}<input className="btn-bg-none" type="button" onClick={handleClick} value="support@freightsmith.net"></input>{formatMessage({ id: "app.thank_you" })}</h6>
                        </main>

                    </Modal.Body>
                    <Modal.Footer className="border-0 justify-content-center main">

                        <button className="button" onClick={isErrorBoundry ? handleChange : handleClose}>Ok</button>

                    </Modal.Footer>
                </div>

            </Modal>
        </React.Fragment>
    )
}

export default injectIntl(ErrornDialog);